const leftPanelLinks = [
    {
        label: "Home",
        value: "/"
    },
    {
        label: "Products",
        value: "/product",
        data: [
            {
                label: "Paper Cups",
                value: "/",
                data: [
                    {
                        label: "Ripple Cups",
                        value: "/",
                        data: [
                            {
                                label: "4 OZ Ripple Paper Cups",
                                valu: "/"
                            },
                            {
                                label: "6 OZ Ripple Paper Cups",
                                valu: "/"
                            },
                            {
                                label: "8 OZ Ripple Paper Cups",
                                valu: "/"
                            },
                            {
                                label: "10 OZ Ripple Paper Cups",
                                valu: "/"
                            },
                            {
                                label: "12 OZ Ripple Paper Cups",
                                valu: "/"
                            },
                            {
                                label: "16 OZ Ripple Paper Cups",
                                valu: "/"
                            }
                        ]
                    },
                    {
                        label: "Single Wall Paper Cups",
                        value: "/",
                        data: [
                            {
                                label: "4 OZ Single Wall Paper Cups",
                                valu: "/"
                            },
                            {
                                label: "6 OZ Single Wall Paper Cups",
                                valu: "/"
                            },
                            {
                                label: "8 OZ Single Wall Paper Cups",
                                valu: "/"
                            },
                            {
                                label: "10 OZ Single Wall Paper Cups",
                                valu: "/"
                            },
                            {
                                label: "12 OZ Single Wall Paper Cups",
                                valu: "/"
                            },
                            {
                                label: "16 OZ Single Wall Paper Cups",
                                valu: "/"
                            }
                        ]
                    },
                    {
                        label: "Double Wall Paper Cups",
                        value: "/",
                        data: [
                            {
                                label: "8 OZ Double Wall Paper Cups",
                                valu: "/"
                            },
                            {
                                label: "10 OZ Double Wall Paper Cups",
                                valu: "/"
                            },
                            {
                                label: "12 OZ Double Wall Paper Cups",
                                valu: "/"
                            },
                            {
                                label: "16 OZ Double Wall Paper Cups",
                                valu: "/"
                            },
                            {
                                label: "20 OZ Double Wall Paper Cups",
                                valu: "/"
                            }
                        ]
                    },
                ]
            },
            {
                label: "Lids",
                value: "/",
                data: [
                    {
                        label: "Locable Sipper Lid",
                        value: "/",
                        data: [
                            {
                                label: "80mm White Lids",
                                value: "/"
                            },
                            {
                                label: "90mm White Lids",
                                value: "/"
                            },
                            {
                                label: "80mm Hips Black Lids",
                                value: "/"
                            },
                            {
                                label: "90mm Hips Black Lids",
                                value: "/"
                            }
                        ]
                    }
                ]
            }
        ]
    },
    {
        label: "About Us",
        value: "/about-us"
    },
    {
        label: "Gallery",
        value: "/gallery"
    },
    {
        label: "Contact",
        value: "/contact"
    }
]

const rightPanelLinks = [

]

const productHomeList = [
    {
        name: "Ripple Wall cups",
        link: "/product/paper-cups/ripple-cups",
        image: require("../assets/images/ripplecup.jpg")
    },
    {
        name: "Single wall Paper Cup",
        link: "/product/paper-cups/single-wall-paper-cups",
        image: require("../assets/images/a50756e904aa545423d55f1dc2c424fe.png")
    },
    {
        name: "Double wall Paper Cups",
        link: "/product/paper-cups/double-wall-paper-cups",
        image: require("../assets/images/double cup.jpg")
    },
    {
        name: "Lids",
        link: "/product/lids",
        image: require("../assets/images/3cd3b713558b9f4c290c13e51b98d225.png")
    }
]

const productSliderList = [
    {
        thumbnail: require('../assets/images/whitepapercup.png'),
        title: "Single wall Paper Cup",
        titleDescription: "Nexus Single Wall Paper Cups are eco-friendly, made from responsibly sourced paper, and ideal for cafes, offices, and events seeking sustainable beverage solutions.",
        linkText: "View Range",
        redirectLink: "/",
        labelImage: require('../assets/images/a4e20a1f5d832bb23d5d8348c5a21f37.png')
    },
    {
        thumbnail: require('../assets/images/double cup.png'),
        title: "Double wall Paper Cup",
        titleDescription: "Premium ripple wall cups designed for heat retention, comfort grip, and customizable branding to elevate your experience.",
        linkText: "View Range",
        redirectLink: "/",
        labelImage: require('../assets/images/a4e20a1f5d832bb23d5d8348c5a21f37.png')
    },
    {
        thumbnail: require('../assets/images/ripple cup.png'),
        title: "Ripple Wall Cup ",
        titleDescription: "Double-wall cups provide smooth insulation, sleek design, and customizable branding for a professional touch",
        linkText: "View Range",
        redirectLink: "/",
        labelImage: require('../assets/images/a4e20a1f5d832bb23d5d8348c5a21f37.png')
    }
]

const letterList = [
    {
        image: require('../assets/images/95747f6bdcba91447a006d2022ac0878.png'),
        title: "Introducing Our New Product Line",
        description: "Discover our latest range of innovative and high-quality products designed to meet your needs with sustainability in mind.",
        navigateLink: "/"
    },
    {
        image: require('../assets/images/94c22b4ae055291be52e11cd7da4d125.png'),
        title: "Sustainability at Its Core",
        description: "We are committed to eco-friendly solutions, ensuring our products are sustainable and responsibly sourced.",
        navigateLink: "/"
    },
    {
        image: require('../assets/images/216e087e762390d0a7107f9c475e6652.png'),
        title: "Awarded for Excellence",
        description: "Our dedication to quality and innovation has earned us recognition and prestigious awards in the industry.",
        navigateLink: "/"
    }
];


const certificateList = [
    require("../assets/images/ek-kadam.png"),
    require("../assets/images/intertek.png"),
    require("../assets/images/Make_In_India-copy.png"),
    require("../assets/images/pfas.png"),
    require("../assets/images/iso.png"),
]

const quickLinks = [
    {
        label: "Home",
        value: "/"
    },
    {
        label: "Product",
        value: "/product"
    },
    {
        label: "About Us",
        value: "/about-us"
    },
    {
        label: "Environmental",
        value: "/environmental"
    }
]

const fouderList = [
    {
        name: "Rahul Vasoya",
        role: "Founders of Nexus paper packs",
        profileImage: require('../assets/images/Untitled design (10).png'),
        socialList: [
            {
                label: "facebook",
                value: ""
            },
            {
                label: "twitter-x",
                value: ""
            },
            {
                label: "instagram",
                value: ""
            }
        ]
    },
    {
        name: "Mihir Thummar",
        role: "Founders of Nexus paper packs",
        profileImage: require('../assets/images/Untitled design (11).png'),
        socialList: [
            {
                label: "facebook",
                value: ""
            },
            {
                label: "twitter-x",
                value: ""
            },
            {
                label: "instagram",
                value: ""
            }
        ]
    }
]

const categoryList = [
    {
        image: require('../assets/images/b43a244c2549b19b71595c7ae342e949.jpeg'),
        name: "Hotels",
        redirectLink: ""
    },
    {
        image: require('../assets/images/6c3b06819c1dfb168eaf3ad36d8f9348.jpeg'),
        name: "Restaurants",
        redirectLink: ""
    },
    {
        image: require('../assets/images/71dd06e17cf05b1dffbc75b3c20219c0.png'),
        name: "Caterers",
        redirectLink: ""
    },
    {
        image: require('../assets/images/830f4b0ff57815c1da86817a6a60dcec.jpeg'),
        name: "Hospitals",
        redirectLink: ""
    }
]

const countryList = [
    {
        label: "CANADA",
        top: "27%",
        left: "23%"
    },
    {
        label: "USA",
        top: "38.5%",
        left: "23.5%"
    },
    {
        label: "UK",
        top: "30.5%",
        left: "48.75%"
    },
    {
        label: "UAE",
        top: "58%",
        left: "51.5%"
    },
    {
        label: "IND",
        top: "50.5%",
        left: "66.5%"
    },
    {
        label: "AUS",
        top: "80%",
        left: "79.5%"
    }
]

const productList = [
    {
        label: "Paper Cups",
        value: "",
        data: [
            {
                label: "Ripple Cups",
                value: "",
                banner: require('../assets/images/bcfe4e574db5ae361e57eda04a2ee840.png'),
                data: [
                    {
                        image: require('../assets/images/4oz.png'),
                        name: "4 OZ Ripple Paper Cups",
                        redirectLink: "",
                        tableList: [
                            {
                                label: "Material",
                                value: "Ripple Paper"
                            },
                            {
                                label: "Paper GSM",
                                value: "195 + 240"
                            },
                            {
                                label: "Top",
                                value: "67 mm"
                            },
                            {
                                label: "Bottom",
                                value: "50 mm"
                            },
                            {
                                label: "Height",
                                value: "63 mm"
                            }
                        ]
                    },
                    {
                        image: require('../assets/images/6oz.png'),
                        name: "6 OZ Ripple Paper Cups",
                        redirectLink: "",
                        tableList: [
                            {
                                label: "Material",
                                value: "Ripple Paper"
                            },
                            {
                                label: "Paper GSM",
                                value: "195 + 240"
                            },
                            {
                                label: "Top",
                                value: "70 mm"
                            },
                            {
                                label: "Bottom",
                                value: "50 mm"
                            },
                            {
                                label: "Height",
                                value: "80 mm"
                            }
                        ]
                    },
                    {
                        image: require('../assets/images/8oz.png'),
                        name: "8 OZ Ripple Paper Cups",
                        redirectLink: "",
                        tableList: [
                            {
                                label: "Material",
                                value: "Ripple Paper"
                            },
                            {
                                label: "Paper GSM",
                                value: "248 + 240"
                            },
                            {
                                label: "Top",
                                value: "80 mm"
                            },
                            {
                                label: "Bottom",
                                value: "56 mm"
                            },
                            {
                                label: "Height",
                                value: "92 mm"
                            }
                        ]
                    },
                    {
                        image: require('../assets/images/10oz.png'),
                        name: "10 OZ Ripple Paper Cups",
                        redirectLink: "",
                        tableList: [
                            {
                                label: "Material",
                                value: "Ripple Paper"
                            },
                            {
                                label: "Paper GSM",
                                value: "298 + 240"
                            },
                            {
                                label: "Top",
                                value: "90 mm"
                            },
                            {
                                label: "Bottom",
                                value: "60 mm"
                            },
                            {
                                label: "Height",
                                value: "96 mm"
                            }
                        ]
                    },
                    {
                        image: require('../assets/images/12oz.png'),
                        name: "12 OZ Ripple Paper Cups",
                        redirectLink: "",
                        tableList: [
                            {
                                label: "Material",
                                value: "Ripple Paper"
                            },
                            {
                                label: "Paper GSM",
                                value: "298 + 240"
                            },
                            {
                                label: "Top",
                                value: "90 mm"
                            },
                            {
                                label: "Bottom",
                                value: "60 mm"
                            },
                            {
                                label: "Height",
                                value: "110 mm"
                            }
                        ]
                    },
                    {
                        image: require('../assets/images/16oz.png'),
                        name: "16 OZ Ripple Paper Cups",
                        redirectLink: "",
                        tableList: [
                            {
                                label: "Material",
                                value: "Ripple Paper"
                            },
                            {
                                label: "Paper GSM",
                                value: "320 + 240"
                            },
                            {
                                label: "Top",
                                value: "90 mm"
                            },
                            {
                                label: "Bottom",
                                value: "60 mm"
                            },
                            {
                                label: "Height",
                                value: "137 mm"
                            }
                        ]
                    }
                ]
            },
            {
                label: "Single Wall Paper Cups",
                value: "",
                banner: require('../assets/images/Untitled design (70).png'),
                data: [
                    {
                        image: require('../assets/images/4oz1.png'),
                        name: "4 OZ Single Wall Paper Cups",
                        redirectLink: "",
                        tableList: [
                            {
                                label: "Material",
                                value: "White Paper"
                            },
                            {
                                label: "Paper GSM",
                                value: "195"
                            },
                            {
                                label: "Top",
                                value: "67 mm"
                            },
                            {
                                label: "Bottom",
                                value: "50 mm"
                            },
                            {
                                label: "Height",
                                value: "63 mm"
                            }
                        ]
                    },
                    {
                        image: require('../assets/images/6oz1.png'),
                        name: "6 OZ Single Wall Paper Cups",
                        redirectLink: "",
                        tableList: [
                            {
                                label: "Material",
                                value: "White Paper"
                            },
                            {
                                label: "Paper GSM",
                                value: "195"
                            },
                            {
                                label: "Top",
                                value: "70 mm"
                            },
                            {
                                label: "Bottom",
                                value: "50 mm"
                            },
                            {
                                label: "Height",
                                value: "80 mm"
                            }
                        ]
                    },
                    {
                        image: require('../assets/images/8oz1.png'),
                        name: "8 OZ Single Wall Paper Cups",
                        redirectLink: "",
                        tableList: [
                            {
                                label: "Material",
                                value: "White Paper"
                            },
                            {
                                label: "Paper GSM",
                                value: "248"
                            },
                            {
                                label: "Top",
                                value: "80 mm"
                            },
                            {
                                label: "Bottom",
                                value: "56 mm"
                            },
                            {
                                label: "Height",
                                value: "92 mm"
                            }
                        ]
                    },
                    {
                        image: require('../assets/images/10oz1.png'),
                        name: "10 OZ Single Wall Paper Cups",
                        redirectLink: "",
                        tableList: [
                            {
                                label: "Material",
                                value: "White Paper"
                            },
                            {
                                label: "Paper GSM",
                                value: "298"
                            },
                            {
                                label: "Top",
                                value: "90 mm"
                            },
                            {
                                label: "Bottom",
                                value: "60 mm"
                            },
                            {
                                label: "Height",
                                value: "96 mm"
                            }
                        ]
                    },
                    {
                        image: require('../assets/images/12oz1.png'),
                        name: "12 OZ Single Wall Paper Cups",
                        redirectLink: "",
                        tableList: [
                            {
                                label: "Material",
                                value: "White Paper"
                            },
                            {
                                label: "Paper GSM",
                                value: "298"
                            },
                            {
                                label: "Top",
                                value: "90 mm"
                            },
                            {
                                label: "Bottom",
                                value: "60 mm"
                            },
                            {
                                label: "Height",
                                value: "110 mm"
                            }
                        ]
                    },
                    {
                        image: require('../assets/images/16oz1.png'),
                        name: "16 OZ Single Wall Paper Cups",
                        redirectLink: "",
                        tableList: [
                            {
                                label: "Material",
                                value: "Ripple Paper"
                            },
                            {
                                label: "Paper GSM",
                                value: "320"
                            },
                            {
                                label: "Top",
                                value: "90 mm"
                            },
                            {
                                label: "Bottom",
                                value: "60 mm"
                            },
                            {
                                label: "Height",
                                value: "137 mm"
                            }
                        ]
                    }
                ]
            },
            {
                label: "Double Wall Paper Cups",
                value: "",
                banner: require('../assets/images/Untitled design (90).png'),
                data: [
                    {
                        image: require('../assets/images/8oz2.png'),
                        name: "8 OZ Double Wall Paper Cups",
                        redirectLink: "",
                        tableList: [
                            {
                                label: "Material",
                                value: "White Paper / Kraft Paper"
                            },
                            {
                                label: "Paper GSM",
                                value: "248 + 250"
                            },
                            {
                                label: "Top",
                                value: "80 mm"
                            },
                            {
                                label: "Bottom",
                                value: "56 mm"
                            },
                            {
                                label: "Height",
                                value: "92 mm"
                            }
                        ]
                    },
                    {
                        image: require('../assets/images/10oz2.png'),
                        name: "10 OZ Double Wall Paper Cups",
                        redirectLink: "",
                        tableList: [
                            {
                                label: "Material",
                                value: "White Paper / Kraft Paper"
                            },
                            {
                                label: "Paper GSM",
                                value: "195 + 240"
                            },
                            {
                                label: "Top",
                                value: "90 mm"
                            },
                            {
                                label: "Bottom",
                                value: "60 mm"
                            },
                            {
                                label: "Height",
                                value: "96 mm"
                            }
                        ]
                    },
                    {
                        image: require('../assets/images/12oz2.png'),
                        name: "12 OZ Double Wall Paper Cups",
                        redirectLink: "",
                        tableList: [
                            {
                                label: "Material",
                                value: "White Paper / Kraft Paper"
                            },
                            {
                                label: "Paper GSM",
                                value: "298 + 250"
                            },
                            {
                                label: "Top",
                                value: "90 mm"
                            },
                            {
                                label: "Bottom",
                                value: "60 mm"
                            },
                            {
                                label: "Height",
                                value: "110 mm"
                            }
                        ]
                    }
                ]
            }
        ]
    },
    {
        label: "Lids",
        value: "",
        data: [
            {
                label: "Locable Sipper Lid",
                value: "",
                banner: require('../assets/images/lids.png'),
                data: [
                    {
                        image: require('../assets/images/80mm white.png'),
                        name: "80mm White Lids",
                        redirectLink: "",
                        tableList: [
                            {
                                label: "Colour",
                                value: "White"
                            },
                            {
                                label: "Product Dimension",
                                value: "80 mm Dia"
                            }
                        ]
                    },
                    {
                        image: require('../assets/images/90mm white.png'),
                        name: "90mm White Lids",
                        redirectLink: "",
                        tableList: [
                            {
                                label: "Colour",
                                value: "White"
                            },
                            {
                                label: "Product Dimension",
                                value: "90 mm Dia"
                            }
                        ]
                    },
                    {
                        image: require('../assets/images/80mm black.png'),
                        name: "80mm Hips Black Lids",
                        redirectLink: "",
                        tableList: [
                            {
                                label: "Colour",
                                value: "Black"
                            },
                            {
                                label: "Product Dimension",
                                value: "80 mm Dia"
                            }
                        ]
                    },
                    {
                        image: require('../assets/images/90mm black.png'),
                        name: "90mm Hips Black Lids",
                        redirectLink: "",
                        tableList: [
                            {
                                label: "Colour",
                                value: "Black"
                            },
                            {
                                label: "Product Dimension",
                                value: "90 mm Dia"
                            }
                        ]
                    }
                ]
            }
        ]
    }
]

const plantSlider = [
    // require('../assets/images/pexels-polesietoys-4492370.jpg'),
    // require('../assets/images/pexels-mikhail-nilov-7821359.jpg'),
    require('../assets/images/pexels-cup-of-couple-8015157.jpg'),
    // require('../assets/images/pexels-pavel-danilyuk-6340789.jpg'),
    require('../assets/images/pexels-pavel-danilyuk-6340704.jpg')
]

const galleryList = [
    require("../assets/images/1ad69f50bb1e2e438e6a99d15a737afc.png"),
    require("../assets/images/6c3b06819c1dfb168eaf3ad36d8f9348.jpeg"),
    require("../assets/images/7e95882315225ecd7e8efd431936781e.jpeg"),
    require("../assets/images/7ec96fe391c141c2ba71d4899edfd13a.png"),
    require("../assets/images/13f48ee604a7233e92e3a735204332a8.png"),
    require("../assets/images/35f280bbaa9b30363b2b9576c801ff0c.png"),
    require("../assets/images/71dd06e17cf05b1dffbc75b3c20219c0.png"),
    require("../assets/images/94c22b4ae055291be52e11cd7da4d125.png"),
    require("../assets/images/216e087e762390d0a7107f9c475e6652.png"),
    require("../assets/images/482a92a381c3fa9ebb1c62ad800dcedb.jpeg"),
    require("../assets/images/830f4b0ff57815c1da86817a6a60dcec.jpeg"),
    require("../assets/images/bff02a084ee213d251e15f529d163f2c.png")
]

const processList = [
    {
        image: require('../assets/images/p1.svg').default,
        title: "Blank"
    },
    {
        image: require('../assets/images/p2.svg').default,
        title: "Body sealing"
    },
    {
        image: require('../assets/images/p3.svg').default,
        title: "Bottom punching"
    },
    {
        image: require('../assets/images/p4.svg').default,
        title: "Bottom knurling"
    },
    {
        image: require('../assets/images/p5.svg').default,
        title: "Discharging cup"
    },
    {
        image: require('../assets/images/p6.svg').default,
        title: "Ready to use"
    },
]

export {
    leftPanelLinks,
    rightPanelLinks,
    productHomeList,
    productSliderList,
    letterList,
    certificateList,
    quickLinks,
    fouderList,
    categoryList,
    countryList,
    productList,
    plantSlider,
    galleryList,
    processList,
}